"use strict";

module.exports = function (element, message) {
    var errorHtml = "<div class=\"alert alert-danger alert-dismissible " +
        "fade show\" role=\"alert\">"+ message + "</div>";

    $(element).append(errorHtml);
};
